module.exports = __webpack_public_path__ + "static/media/294318.c9f97d93.png";